require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 1253
// module chunks = 0